import styled from "styled-components";

// Sidebar collapse/expand toggle button.
export const ToggleButton = styled.button<{ mainColor: string }>`
    width: 100%;
    height: 48px;
    background-color: rgba(0, 0, 0, 0.1);
    border: none;
    color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: rgba(0, 0, 0, 0.2);
    }

    svg {
        width: 24px;
        height: 24px;
        transition: transform 0.3s ease;
    }
`;

// Wrapper around each NavLink's icon + label. Animates the label visibility
// when the sidebar collapses.
export const NavLinkContent = styled.div<{ isCollapsed: boolean }>`
    display: flex;
    align-items: center;
    gap: 12px;
    justify-content: ${({ isCollapsed }) =>
        isCollapsed ? "center" : "flex-start"};
    width: 100%;
    padding: 0 ${({ isCollapsed }) => (isCollapsed ? "0" : "8px")};

    svg {
        width: 20px;
        height: 20px;
        flex-shrink: 0;
    }

    span {
        white-space: nowrap;
        opacity: ${({ isCollapsed }) => (isCollapsed ? "0" : "1")};
        transform: ${({ isCollapsed }) =>
            isCollapsed ? "translateX(-10px)" : "translateX(0)"};
        transition: opacity 0.2s ease, transform 0.2s ease;
        display: ${({ isCollapsed }) => (isCollapsed ? "none" : "inline")};
    }
`;

// Positioning wrapper around each NavItem so the (already-styled) tooltip
// hovers above the right element when the sidebar is collapsed.
export const TooltipWrapper = styled.div`
    position: relative;
    width: 100%;
`;
